import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Steps from "./components/Steps";
import GossipFeed from "./components/GossipFeed";
import Insider from "./components/Insider";
import Discussion from "./components/Discussion";
import CTA from "./components/CTA";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <Steps />
        <GossipFeed />
        <Insider />
        <Discussion />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}